$(document).ready(function(){
  
  $(document).on('click', '.cc-btn', function(){
    $('.cc-window').hide();
  });
  
  $(document).on('click', '.bb-mobile-menu-tab.catz', function(){
    $('.bb-mobile-menu-tab.menz').removeClass('active');
    $(this).addClass('active');
    $('.bb-mobile-menu-menz').removeClass('active');
    $('.bb-mobile-menu-catz').addClass('active');
  });
  $(document).on('click', '.bb-mobile-menu-tab.menz', function(){
    $('.bb-mobile-menu-tab.catz').removeClass('active');
    $(this).addClass('active');
    $('.bb-mobile-menu-catz').removeClass('active');
    $('.bb-mobile-menu-menz').addClass('active');
  });
  $(document).on('click', '.closed', function(){
    $('.open').removeClass('open').addClass('closed');
    $('.down').removeClass('down').addClass('up');
    $(this).removeClass('closed').addClass('open');
    $(this).closest('.has-submenu').find('.bb-mm-submenu').removeClass('up').addClass('down');
  });
  $(document).on('click', '.open', function(){
    $(this).removeClass('open').addClass('closed');
    $(this).closest('.has-submenu').find('.bb-mm-submenu').removeClass('down').addClass('up');
  });
  
  
  var dPostCode = checkCookie();
  
  var restrictPostCodes = ["AB379", "AB387", "AB389", "AB410", "AB411", "AB416", "AB417", "AB418", "AB419", "AB420", "AB421", "AB422", "AB423", "AB424", "AB425", "AB426", "AB427", "AB428", "AB429", "AB431", "AB434", "AB435", "AB436", "AB437", "AB438", "AB439", "AB441", "AB451", "AB452", "AB453", "AB459", "AB510", "AB511", "AB513", "AB514", "AB515", "AB516", "AB517", "AB518", "AB519", "AB526", "AB534", "AB535", "AB536", "AB537", "AB538", "AB539", "AB544", "AB545", "AB546", "AB547", "AB548", "AB549", "AB553", "AB554", "AB555", "AB556", "AB559", "AB561", "AB562", "AB564", "AB565", "AB569", "FK178", "FK188", "FK198", "FK208", "FK218", "IV1", "IV2", "IV3", "IV4", "IV5", "IV6", "IV7", "IV8", "IV9", "IV10", "IV11", "IV12", "IV13", "IV14", "IV15", "IV16", "IV17", "IV18", "IV19", "IV20", "IV21", "IV22", "IV23", "IV24", "IV25", "IV26", "IV27", "IV28", "IV29", "IV30", "IV31", "IV32", "IV33", "IV34", "IV35", "IV36", "IV40", "IV52", "IV53", "IV54", "IV63", "KW14A", "KW14B", "KW14D", "KW14E", "KW14H", "KW14J", "KW14L", "KW14N", "KW14P", "KW14Q", "KW14R", "KW14S", "KW14T", "KW14U", "KW14W", "KW14X", "KW14Y", "KW14Z", "KW2", "KW3", "KW4", "KW5", "KW6", "KW7", "KW8", "KW9", "KW10", "KW11", "KW12", "KW13", "KW14", "PA212", "PA223", "PA237", "PA238", "PA239", "PA248", "PA258", "PA268", "PA278", "PA286", "PA289", "PA296", "PA308", "PA318", "PA319", "PA328", "PA331", "PA344", "PA345", "PA349", "PA351", "PA364", "PA371", "PA384", "PA394", "PA404", "PH152", "PH165", "PH169", "PH172", "PH185", "PH191", "PH201", "PH211", "PH221", "PH233", "PH243", "PH253", "PH263", "PH269", "PH304", "PH314", "PH324", "PH336", "PH337", "PH339", "PH344", "PH354", "PH364", "PH374", "PH384", "PH394", "PH404", "PH412", "PH414", "PH494", "PH504", "HS", "IV418", "IV428", "IV438", "IV448", "IV458", "IV468", "IV478", "IV488", "IV499", "IV510", "IV519", "IV558", "IV568", "KA278", "KA279", "KA280", "KA289", "KW", "PA200", "PA202", "PA209", "PA417", "PA427", "PA429", "PA437", "PA447", "PA457", "PA467", "PA477", "PA487", "PA497", "PA607", "PA617", "PA626", "PA636", "PA646", "PA656", "PA666", "PA676", "PA686", "PA696", "PA706", "PA716", "PA726", "PA736", "PA746", "PA756", "PA766", "PA776", "PA786", "PH424", "PH434", "PH444", "ZE", "BT41", "BT61", "BT54", "BT39", "BT44", "BT43", "BT42", "BT53", "BT24", "BT32", "BT19", "BT20", "BT5", "BT4", "BT11", "BT6", "BT7", "BT8", "BT9", "BT3", "BT17", "BT2", "BT16", "BT15", "BT14", "BT13", "BT10", "BT12", "BT57", "BT38", "BT81", "BT31", "BT52", "BT51", "BT80", "BT62", "BT63", "BT64", "BT65", "BT66", "BT67", "BT29", "BT21", "BT30", "BT71", "BT70", "BT94", "BT93", "BT92", "BT75", "BT26", "BT40", "BT49", "BT27", "BT28", "BT48", "BT46", "BT45", "BT33", "BT35", "BT34", "BT37", "BT36", "BT22", "BT23", "BT78", "BT79", "BT56", "BT55", "BT82", "IM", "PO30", "PO31", "PO32", "PO33", "PO34", "PO35", "PO36", "PO37", "PO38", "PO39", "PO40", "PO41", "GY", "JE", "G1", "G2", "G3", "G4", "G5", "G6", "G7", "G8"];
  var restrictProducts = ["37644977176773", "39310614003909", "37644976783557", "37644647825605", "37644631441605", "37644632260805", "37644701073605", "37644631998661", "37644790005957", "37644505186501", "37644575998149", "37644449710277", "37644444991685", "37644576981189", "37644514689221", "37644520718533", "37644700287173", "37788130672837", "37644655001797", "37644700451013", "37644698321093", "37644700025029", "37644789219525", "37644701008069", "37644655100101", "37644505546949", "37644791546053", "37644505743557", "37644507119813", "37644505612485", "37644503613637", "37644607881413", "37644444205253", "37644443943109", "37644978421957", "37644853182661", "37644656246981", "37644991692997", "37644705169605", "37644837650629", "37644976324805", "37644837945541", "37644838240453", "37644570558661", "37644570362053", "37644571148485", "37644655395013", "37644579078341", "37644570820805", "37644656738501", "37644570296517", "37644571345093", "37644614631621", "37644521668805", "37644521603269", "37644529664197", "37644445253829", "37644520751301", "37644502008005", "37644505284805", "37644504400069", "37644530843845", "37644506792133", "37644503646405", "37644505841861", "37644505088197", "37644503679173", "37644504989893", "37644505022661", "37644506104005", "37644506497221", "37644506398917", "37644505940165", "37644505972933", "37644506235077", "37644506267845", "37645018595525", "37645018562757", "37645018529989", "37644992544965", "37644992577733", "37644992512197", "37644992020677", "37644991987909", "37644991856837", "37644991922373", "37644978290885", "37644978258117", "37644978356421", "37644977504453", "37644978028741", "37644977832133", "37644977799365", "37644977668293", "37644977733829", "37644977078469", "37644977635525", "37644977569989", "37644977275077", "37644977111237", "37644977242309", "37644977209541", "37644976914629", "37644976849093", "37644976750789", "37644976652485", "37644976586949", "37644976718021", "37644976554181", "37644976521413", "37644976455877", "37644976390341", "37644976423109", "37644976259269", "37644975866053", "37644975669445", "37644838764741", "37644838699205", "37644838731973", "37644838568133", "37644838633669", "37644838076613", "37644838600901", "37644838535365", "37644838469829", "37644838404293", "37644838273221", "37644838338757", "37644838207685", "37644838142149", "37644838109381", "37644838011077", "37644837978309", "37644837912773", "37644837847237", "37644837814469", "37644820971717", "37644791677125", "37644790956229", "37644790628549", "37644790464709", "37644790726853", "37644790366405", "37644790235333", "37644790104261", "37644705923269", "37644705693893", "37644705726661", "37644705562821", "37644704972997", "37644705005765", "37644700975301", "37644700385477", "37644700090565", "37644700188869", "37644698026181", "37644689244357", "37644688851141", "37644685639877", "37644685377733", "37644656836805", "37644656804037", "37644656607429", "37644656509125", "37644656443589", "37644656312517", "37644656181445", "37644655788229", "37644655886533", "37644656083141", "37644653625541", "37644653592773", "37644685377733", "37644656836805", "37644656804037", "37644656607429", "37644656509125", "37644656443589", "37644656312517", "37644656181445", "37644655788229", "37644655886533", "37644656083141", "37644653625541", "37644653592773", "37644648284357", "37644648218821", "37644648087749", "37644632391877", "37644632424645", "37644631376069", "37644632228037", "37644632162501", "37644631244997", "37644631670981", "37644631572677", "37644631244997", "37644631670981", "37644631572677", "37644631539909", "37644631638213", "37644631507141", "37644631277765", "37644631343301", "37644621611205", "37644606210245", "37644606243013", "37644604637381", "37644603916485", "37644602900677", "37644599328965", "37644595265733", "37644595003589", "37644594905285", "37644589793477", "37644589695173", "37644579012805", "37644575768773", "37644575211717", "37644575244485", "37644575211717", "37644575244485", "37644571771077", "37644571803845", "37644571312325", "37644571082949", "37644571050181", "37644570427589", "37644569870533", "37644551717061", "37644551684293", "37644551618757", "37644549423301", "37644549193925", "37644549292229", "37644549259461", "37644549128389", "37644533563589", "37644447383749", "37644443844805", "37644442861765", "37644510855365", "37644448137413", "37644444795077", "37644443254981", "37644443746501", "37644447252677", "37644450267333", "37644443287749", "37644443320517", "37644446335173", "37644450070725", "37644443025605", "37644443713733", "37644447482053", "37644443877573", "37644446695621", "37644446466245", "37644514721989", "37644449939653", "37644449906885", "37644446662853", "37644449906885", "37644449841349", "37644445941957", "37644444827845", "37644445974725", "37644442960069", "37644442927301", "37644447023301", "37644446728389", "37644443648197", "37644444139717", "37644447219909", "37644446826693", "37644443615429", "37644445581509", "37644443156677", "37644499419333", "37644449743045", "37644445155525", "37644445647045", "37644446597317", "37644444860613", "37644449775813", "37644444565701", "37644447416517", "37644529336517", "37644445188293", "37644444500165", "37644444467397", "37644445089989", "37644514558149", "37644448301253", "37644521865413", "37644446531781", "37644446400709", "37644448202949", "37644450037957", "37644521636037", "37644514132165", "37644446040261", "37644445778117", "37644499517637", "37644445319365", "37644447154373", "37644520882373", "37644444926149", "37644447088837", "37644443123909", "37644443123909", "37644450431173", "37644446924997", "37644444303557", "37644450136261", "37644444401861", "37644521734341", "37644447350981", "37644450332869", "37644448235717", "37644446957765", "37644443779269", "37644450201797", "37644444270789", "37644445024453", "37644444172485", "37644444729541", "37644445909189", "37644445352133", "37644450103493", "37644445515973", "37644449677509", "37644446073029", "37644445057221", "37644521832645", "37644443091141", "37644521767109", "37644445810885", "37644446269637", "37644445712581", "37644443975877", "37644705759429", "37644622102725", "37644503515333", "37644503253189", "37644499878085", "37644445876421", "37644450398405" ];
  var scotlandPostCodes = ["AB", "DD", "DG", "EH1", "EH2", "EH3", "EH4", "EH5", "EH6", "EH8", "FK", "G1", "G2", "G3", "G4", "G5", "G6", "G7", "G8", "G92", "G94", "G96", "IV1", "KA", "KY", "ML", "PA1", "PA2", "PA3", "PA4", "PA5", "PA6", "PA7", "PH", "TD"];
  var ukMainlandPostCodes = ["AL", "B1", "B2", "B3", "B4", "B5", "B6", "B7", "B8", "B9", "BA", "BB", "BD", "BH", "BL", "BN", "BR", "BS", "CA", "CB", "CF", "CH", "CM", "CO", "CR", "CT", "CV", "CW", "DA", "DE", "DH", "DL", "DN", "DT", "DY", "E1", "E2", "E3", "E4", "E5", "E6", "E7", "E8", "E9", "EC", "EN", "EX", "FY", "GL", "GU", "HA", "HD", "HG", "HP", "HR", "HU", "HX", "IG", "IP", "KT", "L1", "L2", "L3", "L4", "L5", "L6", "L7", "L8", "L9", "LA", "LD", "LE", "LL", "LN", "LS", "LU", "M1", "M2", "M3", "M4", "M5", "M6", "M7", "M8", "M9", "ME", "MK", "N1", "N2", "N3", "N4", "N5", "N6", "N7", "N8", "N9", "NE", "NG", "NN", "NP", "NR", "NW", "OL", "OX", "PE", "PL", "PO1", "PO2", "PO35A", "PO35B", "PO35C", "PO35D", "PO35E","PO35F", "PO35G", "PO35H", "PO35I", "PO35J", "PO35K", "PO35L", "PO35M", "PO35N", "PO35O", "PO35P", "PO35Q", "PO35R", "PO35S", "PO35T", "PO35U", "PO35V", "PO35W", "PO35X", "PO35Y", "PO35Z", "PO36A", "PO36B", "PO36C", "PO36D", "PO36E", "PO36F", "PO36G", "PO36H", "PO36I", "PO36J", "PO36K", "PO36L", "PO36M", "PO36N", "PO36O", "PO36P", "PO36Q", "PO36R", "PO36S", "PO36T", "PO36U", "PO36V", "PO36W", "PO36X", "PO36Y", "PO36Z", "PO5", "PO6", "PO7", "PO8", "PO9", "PO10", "PR", "RG", "RH", "RM", "S1", "S2", "S3", "S4", "S5", "S6", "S7", "S8", "S9", "SA", "SE", "SG", "SK", "SL", "SM", "SN", "SO", "SP", "SR", "SS", "ST", "SW", "SY", "TA", "TF", "TN", "TQ", "TR1", "TR2", "TR3", "TR4", "TR5", "TR6", "TR7", "TR8", "TR9", "TS", "TW", "UB", "W1", "W2", "W3", "W4", "W5", "W6", "W7", "W8", "W9", "WA", "WC", "WD", "WF", "WN", "WR", "WS", "WV", "YO" ];
  var localPostCodes = ["IG11", "IG12", "IG13", "IG14", "IG18", "IG19", "IG2", "IG3", "IG4", "IG5", "IG6", "IG8", "IG9", "E105", "E106", "E107", "E109", "E111", "E112", "E113", "E114", "E119", "E125", "E126", "E129", "E130", "E133", "E138", "E139", "E151", "E152", "E153", "E154", "E159", "E161", "E162", "E163", "E164", "E169", "E170", "E173", "E174", "E175", "E176", "E177", "E178", "E179", "E181", "E182", "E189", "RM1", "RM52", "RM53", "RM6", "RM7", "RM8", "RM9", "SE280", "SE288", "SE289", "SE181", "SE182", "SE183", "SE184", "SE185", "SE186", "SE187", "SE189", "SE7" ];
  var scotlandZone4 = ["HS1", "HS2", "HS3", "HS4", "HS5", "HS6", "HS7", "HS8", "HS9", "IV41", "IV42", "IV43", "IV44", "IV45", "IV46", "IV47", "IV48", "IV49", "IV51", "IV55", "IV56", "KA27", "KA28", "KW15", "KW16", "KW17", "PA20", "PA41", "PA42", "PA43", "PA44", "PA45", "PA46", "PA47", "PA48", "PA49", "PA60", "PA61", "PA62", "PA63", "PA64", "PA65", "PA66", "PA67", "PA68", "PA69", "PA70", "PA71", "PA72", "PA73", "PA74", "PA75", "PA76", "PA77", "PA78", "PH42", "PH43", "PH44", "ZE1", "ZE2", "ZE3"];
  function checkRestriction() {
    var tempMatchChk;
    for(var i=0; i<restrictPostCodes.length; i++) {
      tempMatchChk = dPostCode.startsWith(restrictPostCodes[i]);
      if(tempMatchChk) {
        return "TRUE";
      }
    }
    return "FALSE";
  }

  function isThisCart() {
    var cartPageCheck = document.getElementsByClassName('template-cart');
      if (cartPageCheck.length > 0) {
        return true;
      } else {
        return false;
      }
  }
  function checkScotland() {
    var tempScotChk;
    for(var i=0; i<scotlandPostCodes.length; i++) {
      tempScotChk = dPostCode.startsWith(scotlandPostCodes[i]);
      if(tempScotChk) {
        return "TRUE";
      }
    }
    return "FALSE";
  }

  function noPerishables() {
    var scotZone4;
    for(var i=0; i<scotlandZone4.length; i++) {
      scotZone4 = dPostCode.startsWith(scotlandZone4[i]);
      if(scotZone4) {
        return true;
      }
    }
  }
  
  function checkLocal() {
    var templocalChk;
    for(var i=0; i<localPostCodes.length; i++) {
      templocalChk = dPostCode.startsWith(localPostCodes[i]);
      if(templocalChk) {
        return "TRUE";
      }
    }
    return "FALSE";
  }
  
  function hideRestrictATC() {
    var bodyEle = document.querySelector('body');
    if(bodyEle.classList.contains("template-index") || bodyEle.classList.contains("template-collection")) {
      
      var elm = document.getElementsByClassName('productitem--action-trigger');
      for(var i=0; i<elm.length; i++) {
      for(var r=0; r<restrictProducts.length; r++) {
        let elmTempAttr = elm[i].getAttribute('data-variant-id');
        if(elmTempAttr == restrictProducts[r]) {
          elm[i].classList.add("hide-this");
          elm[i].disabled = true;
          var butText = elm[i].getElementsByClassName('atc-button--text');
          for(var y=0; y<butText.length; y++) {
            butText[y].innerHTML = "Unavailable at " + dPostCode;
          }
        }
      }
    }
    } else if(bodyEle.classList.contains("template-product")) {
      var elm = document.getElementsByClassName('restricted-product');
      if(elm.length > 0) {
        var pBtn = document.getElementsByClassName('product-form--regular');
        pBtn[0].classList.add("ua-msg");
        pBtn[0].innerHTML = '<span class="bb-p-ua-text">Unavailable for delivery at ' + dPostCode + '</span>';
      }
    }
  }
  function createCookie(cookieName,cookieValue,daysToExpire) {
          var date = new Date();
          date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
          document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString() + "; path=/";
  }
  function accessCookie(cookieName) {
          var name = cookieName + "=";
          var allCookieArray = document.cookie.split(';');
          for(var i=0; i<allCookieArray.length; i++) {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
       	  }
        	return "";
        }
  function disableATC() {
    var bodyEle = document.querySelector('body');
    if(bodyEle.classList.contains("template-index") || bodyEle.classList.contains("template-collection")) {
      var atcButtons = document.getElementsByClassName('productitem--action-trigger');
      for(var i=0; i<atcButtons.length; i++) {
        atcButtons[i].disabled = true;
        atcButtons[i].parentNode.classList.add('atcdisabled');
      }
    }
    if(bodyEle.classList.contains("template-product")) {
      var pBtn = document.getElementsByClassName('product-form--regular');
      pBtn[0].classList.add("ua-msg");
      pBtn[0].innerHTML = '<span class="bb-p-upc-text"><a href="javascript:void(0);" class="bb-p-upc-btn">Add your postcode</a> to start adding products to your cart</span>';
	}
  }
  function checkCookie() {
          var postC = accessCookie("cusPostCode");
    if (postC!="") {
        	return postC;
    } else {
      return "";
    }
   }
  function showPostCodeSuccess() {
    document.getElementById("postcode-alert-msg").classList.add("success");
    document.getElementById("postcode-alert-msg").innerHTML = "Delivery postcode updated!";
  }
  function removePostCodeSuccess() {
    document.getElementById("postcode-alert-msg").classList.remove("success");
    document.getElementById("postcode-alert-msg").innerHTML = "";
    $('.bb-fs-bg').removeClass('show');
  }
  function showPostCodeError() {
    document.getElementById("postcode-alert-msg").classList.add("error");
    document.getElementById("postcode-alert-msg").innerHTML = "Please enter a valid postcode";
  }
  function removePostCodeAlert() {
    document.getElementById("postcode-alert-msg").classList.remove("success");
    document.getElementById("postcode-alert-msg").classList.remove("error");
    document.getElementById("postcode-alert-msg").innerHTML = "";
    $('.bb-fs-bg').removeClass('show');
  }
  function hideCalFunc() {
    var calEle = document.getElementsByClassName("ot-delivery-date-input");
    if(calEle.length > 0) {
    document.getElementById("ot-datepicker").removeAttribute("required");
    document.getElementById("ot-datepicker").disabled = true;
    $('.ot-delivery-date-require-text').addClass('unavailable').text('Date selection is unavailable for your postcode');
    document.getElementById("bb-checkout").disabled = false;
    } else {
      hideCalendar();
    }
  }
  function hideCalForResFunc() {
    var bbCO = document.getElementById("bb-checkout");
    if(bbCO) {
      document.getElementById("bb-checkout").classList.remove("disabled");
    } else {
      hideCalForRes();
    }
  }
  function hideCalForRes() {
    setTimeout(function(){
      	hideCalForResFunc();
      }, 1000);
  }
  
  function bbHideCalFunc() {
    var calEle = document.getElementsByClassName("ot-delivery-date");
    if(calEle.length > 0) {
    $('.ot-delivery-date').addClass('hide');
    } else {
      bbHideCal();
    }
  }
  function hideCalendar() {
    setTimeout(function(){
      	hideCalFunc();
      }, 3000);
  }
  function bbHideCal() {
    setTimeout(function(){
      	bbHideCalFunc();
      }, 1000);
  }
  
  $(document).on('click', '.bb-weekday', function(){
    document.getElementById("bb-delivery-date").classList.add("show");
    document.getElementById("bb-delivery-handler").classList.remove("show");
    document.getElementById("bb-delivery-changer").classList.add("show");
  });
  
  $(document).on('click', '#bb-sat-info', function(){
    document.getElementById("bb-sat-bg").classList.add("show");
  });
  
  $(document).on('click', '.bb-delivery-changer', function(){
    location.reload();
  });
  
  $(document).on('click', '#bb-postcode-click', function(){
    $('.bb-fs-bg').addClass('show');
    if(dPostCode != '') {
      document.getElementById("set-postcode").value = dPostCode;
    }
  });
  
  $(document).on('click', '.bb-p-upc-btn', function(){
    $('.bb-fs-bg').addClass('show');
  });
  
  $(document).on('click', '.postcode-change', function(){
    var ckVal = document.getElementById("set-postcode").value;
    ckVal = ckVal.replace(/\s/g,'').toUpperCase();
    
    if(/^([a-zA-Z]{1,2}\d{2,3}[a-zA-Z]{2})$/.test(ckVal) || /^([a-zA-Z]{1}\d{1}[a-zA-Z]{1}\d{1}[a-zA-Z]{2})$/.test(ckVal) || /^([a-zA-Z]{2}\d{1}[a-zA-Z]{1}\d{1}[a-zA-Z]{2})$/.test(ckVal)) {
      showPostCodeSuccess();
      var ckName = "cusPostCode";
      var ckExpire = 365;
      var ckV = ckVal;
      createCookie(ckName, ckV, ckExpire);
      dPostCode = ckVal;
      console.log(dPostCode);
      setTimeout(function(){
      	removePostCodeSuccess();
      }, 2000);
      location.reload();
    } else {
      showPostCodeError();
    }
  });
  
  $(document).on('click', '.atcdisabled', function(){
    $('.bb-fs-bg').addClass('show');
  });
  
  $(document).on('click', '#proxy-checkout', function(){
    $('.uiHeading').addClass('blink');
  });
  
  $(document).on('click', '.postcode-close', function(){
    removePostCodeAlert();
  });
  
  $(document).on('click', '.sat-close', function(){
    document.getElementById("bb-sat-bg").classList.remove("show");
    //location.reload();
  });
  
  $(document).on('click', '#sat-confirm', function(){
    document.getElementById("bb-sat-bg").classList.remove("show");
  });
  
  $(document).on('click', '#bb-checkout.disabled', function(e){
    e.preventDefault();
  });
  
  $(document).on('click', '.show-pc-alert', function(e){
    e.preventDefault();
    $('.bb-fs-bg').addClass('show');
  });
  
  if(dPostCode != '') {
    document.getElementById("bb-postcode").innerHTML = dPostCode;
    var pcMatch = checkRestriction();
    if(pcMatch == "TRUE") {
      var cartPageCheck = document.getElementsByClassName('template-cart');
      if (cartPageCheck.length > 0) {
        hideCalForRes();
      } /** else {
        hideRestrictATC();
      }**/
    } else {
      var cartPageCheck = document.getElementsByClassName('template-cart');
      if (cartPageCheck.length > 0) {
        var scotlandMatch = checkScotland();
        if(scotlandMatch == "TRUE") {
          hideCalForRes();
          
        } else {
            
          	/*document.getElementById("bb-local-delivery-date").classList.add("show");
          	document.querySelector(".bb-cart-info").classList.add("show");
            document.getElementById("bb-checkout").classList.remove("disabled");
            setTimeout(function(){
               document.getElementById("bb-refresh").classList.add("show");
            }, 10000);
          
          } else {
          
          var bbRemoveDiv = document.getElementsByClassName('bb-remove-div');
      if (bbRemoveDiv.length > 0) {
        bbRemoveDiv[0].remove();
        }*/
          
          document.getElementById("bb-delivery-date").classList.add("show");
          document.getElementById("proxy-checkout").classList.add("show");
          document.querySelector(".bb-cart-info").classList.add("show");
          setTimeout(function(){
             document.getElementById("bb-refresh").classList.add("show");
    	  }, 10000);
          
          
          //}
          
        }
      }
    }
    /*var localMatch = checkLocal();
    	if(localMatch == "TRUE") {
        	$('.local-announce-text').addClass('show');
        } else {
        	$('.announce-text').addClass('show');
        }*/
    
  } else {
    if(isThisCart()) {
      $('.bb-fs-bg').addClass('show');
        var pam = document.getElementsByClassName('postcode-alert-main')
        pam[0].innerHTML = "Confirm your postcode to continue";
    }
    /*var cartPageCheck = document.getElementsByClassName('template-cart');
      if (cartPageCheck.length > 0) {
        $('.bb-fs-bg').addClass('show');
        var pam = document.getElementsByClassName('postcode-alert-main')
        pam[0].innerHTML = "Confirm your postcode to continue";
      }*/
    //disableATC();
  }

});